export function getConfiguration(globalState, matchingContextId) {
    return globalState.matching.contexts[matchingContextId].configurationFn(globalState);
}

export function getState(globalState, matchingContextId) {
    return globalState.matching.contexts[matchingContextId];
}
